/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Header from "../header/header"
import { ToastContainer } from "react-toastify"
import styles from "./inner-layout.module.scss"
import ModalWrapper from "../../common/modal/modal-wrapper/modal-wrapper"

const InnerLayout = ({ children }) => {

  let title = 'AFPA'
  if (process.env.GATSBY_USE_FHAA === 'true') {
    title = 'FHAA'
  }
  else {
    title = 'AFPA'
  }

  return (
    <div className={styles?.wrapper}>
      {/* Every layout needs this to be able to display reusable modal windows (e.g. alertModal) */}
      <ModalWrapper />
      <Header siteTitle={title} />
      <div className={styles?.layout}>
        <div className={styles?.top}></div>
        <div className={styles?.container}>{children}</div>
      </div>
      <ToastContainer />
    </div>
  )
}

InnerLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default InnerLayout
